module.exports = __webpack_public_path__ + "img/foot_pic.930b54ec.png";